import { ref } from 'vue';

/**
 * Small utility for toggling a value between true and false
 *
 * @param {*} initValue initial value
 * @returns method and toggle value
 */

function useToggler () {
  var initValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var toggleValue = ref(initValue);
  /**
   * Toggle from true->false and vice versa
   */

  function toggle() {
    toggleValue.value = !toggleValue.value;
  }
  /**
   * Force a value (true|false)
   * @param value true|false
   */


  function set(value) {
    toggleValue.value = value;
  }

  return {
    toggleValue: toggleValue,
    toggle: toggle,
    set: set
  };
}

export { useToggler as u };
